export default __webpack_public_path__ + "static/media/bg.40ec60d3.png";